export const profile = {
  name: "Gauri Ambekar",
  firstName: "Gauri",
  lastName: "Ambekar",
  headline: "Product Manager — AI & SaaS Products",
  currentRole: "Product Manager, JioPC",
  currentCompany: "Reliance Jio",
  location: "India",
  availability: "Open to product leadership roles",
  yearsExperience: "6",
  summary:
    "Product Manager with 6 years building AI and SaaS products end-to-end, from discovery and roadmap to launch. Currently leading JioPC at Reliance Jio and drove the flagship Jio AI Stack showcase at the India AI Impact Summit 2026. Turns customer research into product decisions, with strengths in data-driven prioritization and cross-functional execution across engineering, design, and go-to-market.",
  email: "ambekargauri8@gmail.com",
  phone: "+91 8830378068",
  phoneHref: "+918830378068",
  linkedin: "https://www.linkedin.com/in/gauriambekar/",
};

export const stats = [
  { value: "6 yrs", label: "experience" },
  { value: "120+", label: "user interviews" },
  { value: "200+", label: "channel partners onboarded" },
  { value: "20%", label: "lift in acquisition (AirFiber GST feature)" },
];

export const caseStudy = {
  title: "JioPC Onboarding Redesign",
  subtitle:
    "Cutting onboarding friction for a first-of-its-kind TV computing product",
  chapters: [
    {
      label: "Context",
      body:
        "JioPC turns the Jio set-top box into a cloud-based desktop — bringing computing to TV screens for the first time. There was no existing UX playbook for \u201Cusing a TV as a computer,\u201D so onboarding had to be built from scratch.",
    },
    {
      label: "Discover",
      body:
        "Ran 120+ user interviews across early cohorts to map exactly where users got stuck — device setup, login, and navigating a TV-first interface with no established interaction patterns to borrow from.",
    },
    {
      label: "Define",
      body:
        "Used those findings to scope the MVP around the highest-friction moments first, rather than building every feature at once. Authored PRDs with explicit acceptance criteria for onboarding, login, and usage flows, giving engineering and QA a shared definition of \u201Cdone\u201D and cutting back-and-forth during development.",
    },
    {
      label: "Deliver",
      body:
        "Shipped the redesigned onboarding, login, and usage flows — reducing rework for the dev team and cutting onboarding failures across test cohorts.",
    },
  ],
};

export const manifesto = [
  {
    no: "01",
    title: "Discover",
    body:
      "Every product decision starts with the customer. 120+ interviews, market research, and hard data — translated into requirements teams can build against.",
  },
  {
    no: "02",
    title: "Define",
    body:
      "Sharp MVP scope and PRDs with clear acceptance criteria. Aligning user priorities with engineering, design, and go-to-market so the right thing ships.",
  },
  {
    no: "03",
    title: "Deliver",
    body:
      "From onboarding flows to enterprise launches — driving measurable outcomes in acquisition, efficiency, and adoption across AI and SaaS products.",
  },
];

export const marqueeItems = [
  "RELIANCE JIO",
  "JIOPC",
  "TATA CONSULTANCY SERVICES",
  "BRAND IT UP",
  "ACCENTURE",
  "AI & SAAS PRODUCTS",
  "PRODUCT STRATEGY",
  "6+ YEARS",
];

export const experience = [
  {
    company: "Reliance Jio Infocomm Limited",
    role: "Product Manager — JioPC",
    period: "Feb 2025 — Present",
    points: [
      "Own the product lifecycle for JioPC, a cloud-based desktop on the Jio STB that brings computing to TV users.",
      "Ran 120+ user interviews to uncover setup and UI friction, translating findings into requirements that smoothed onboarding and TV-interface navigation.",
      "Defined the MVP scope and core feature set, aligning user priorities with development teams.",
      "Authored PRDs with clear acceptance criteria for onboarding, login, and usage flows, reducing rework and cutting onboarding failures across test cohorts.",
    ],
  },
  {
    company: "Reliance Jio",
    role: "Product Manager, Jio Enterprise SMB (AirFiber)",
    period: "Jun 2023 — Feb 2025",
    points: [
      "Launched Jio AirFiber for small hotels, capturing market insights and defining a tailored CVP.",
      "Ran comprehensive market research, identifying GST compliance as a critical feature that lifted customer acquisition by 20%.",
      "Built a WhatsApp automation bot that cut approval times by 13% and improved operational efficiency by 15%.",
      "Onboarded 200+ channel partners as JBAs, driving customer acquisition in the hospitality segment.",
    ],
  },
  {
    company: "Tata Consultancy Services",
    role: "Associate System Analyst",
    period: "Mar 2021 — Jun 2022",
    points: [
      "Defined and executed test plans for ADAS product features, ensuring high reliability and safety standards.",
      "Automated testing workflows, reducing manual effort by 50% and accelerating release cycles.",
    ],
  },
  {
    company: "Brand It Up",
    role: "Product Marketing & Analytics Lead",
    period: "Jun 2020 — Mar 2021",
    points: [
      "Improved landing-page responsiveness and integrated payment gateways (Razorpay, PayU, Paytm) with e-commerce platforms using APIs and webhooks.",
      "Assessed page data using Microsoft Clarity, identifying improvements that increased conversion rates.",
      "Optimised checkout workflows, improving transaction success rate and reducing payment drop-offs.",
    ],
  },
  {
    company: "Accenture",
    role: "Product Associate",
    period: "Sept 2019 — Mar 2020",
    points: [
      "Configured SAP MM modules and improved master data structures to enhance system reliability.",
      "Diagnosed and resolved 8+ issues per day through root-cause analysis and clear stakeholder communication, maintaining 90% satisfaction.",
    ],
  },
];

export const leadership = [
  {
    id: "ai-summit",
    event: "India AI Impact Summit 2026",
    body:
      "Led the end-to-end product showcase for the Jio AI Stack, translating a six-layer AI platform into an executive-ready, customer-centric experience.",
    images: [
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_jio-senior-profile/artifacts/6zxfpkw0_WhatsApp%20Image%202026-09-10%20at%2023.07.58.jpeg",
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_jio-senior-profile/artifacts/zbb1svls_WhatsApp%20Image%202026-09-10%20at%2023.07.58%20%282%29.jpeg",
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_jio-senior-profile/artifacts/c2em3zn0_WhatsApp%20Image%202026-09-10%20at%2023.07.57.jpeg",
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_jio-senior-profile/artifacts/uetmfeb9_WhatsApp%20Image%202026-09-10%20at%2023.07.57%20%281%29.jpeg",
    ],
  },
  {
    id: "imc-2025",
    event: "India Mobile Congress 2025",
    body:
      "Owned Enterprise Pavilion strategy across product positioning, visitor journeys, and cross-functional execution.",
    images: [
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_jio-senior-profile/artifacts/ter362pr_WhatsApp%20Image%202026-09-10%20at%2023.07.59.jpeg",
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_jio-senior-profile/artifacts/d9m1c55w_WhatsApp%20Image%202026-09-10%20at%2023.07.59%20%281%29.jpeg",
    ],
  },
];

export const skills = [
  {
    name: "Product Strategy & Management",
    items: ["Agile", "Scrum", "Product Roadmap", "PRD", "Product Lifecycle Management"],
  },
  {
    name: "Research & Analysis",
    items: ["Market Research", "A/B Testing", "Data Analysis", "SQL", "Funnel Optimization"],
  },
  {
    name: "Tools",
    items: ["Looker Studio", "Microsoft Clarity", "Tableau", "Jira", "Asana", "Clever Tap", "Figma", "Marketo"],
  },
];

export const education = [
  {
    program: "PGP in Marketing Management",
    institution: "Jio Institute",
    period: "Jun 2022 — May 2023",
  },
  {
    program: "Neuro-Marketing and Future Consumer Experience",
    institution: "NTU Singapore",
    period: "Mar 2023",
  },
  {
    program: "Bachelor's in Information Technology",
    institution: "University of Pune, India",
    period: "Aug 2016 — May 2019",
  },
];

export const certifications = [
  "Google Project Management",
  "Agile with Atlassian Jira",
  "Product Management — PMI",
];

export const achievements = [
  "Published research paper: Chatbot Application for Agriculture (AI/ML pattern matching), IJRDT Vol-11, Issue 4.",
  "X-Culture Global Collaboration Competition — ranked among the top 140 finalists out of 1,289+ global teams.",
];
